<script lang="ts">
    let { children } = $props();
</script>

<div class="prose-admiral">
    {@render children()}
</div>
